/**
 * @prettier
 */

import { STEPS } from './steps';
import FileUpload from '../SingleSampleFlowSteps/FileUpload';
import PhotoCrop from '../SingleSampleFlowSteps/PhotoCrop';
import MultiUploadHelp from '../SingleSampleFlowSteps/MultiUploadHelp';
import Customization from '../SingleSampleFlowSteps/Customization';
import WeddingDetailsForm from '../SingleSampleFlowSteps/WeddingDetailsForm';
import ShippingDetailsForm from '../SingleSampleFlowSteps/ShippingDetailsForm';
import AccountDetailsForm from '../SingleSampleFlowSteps/AccountDetailsForm';
import SamplePreviewStage from '../SingleSampleFlowSteps/SamplePreviewStage';
import FlowCompletion from '../SingleSampleFlowSteps/FlowCompletion';

export const STEP_DATA = {
  [STEPS.FILE_UPLOAD]: {
    component: FileUpload,
    key: STEPS.FILE_UPLOAD,
  },
  [STEPS.PHOTO_CROP]: {
    component: PhotoCrop,
    key: STEPS.PHOTO_CROP,
  },
  [STEPS.MULTI_UPLOAD_HELP]: {
    component: MultiUploadHelp,
    key: STEPS.MULTI_UPLOAD_HELP,
  },
  [STEPS.CUSTOMIZATION]: {
    component: Customization,
    key: STEPS.CUSTOMIZATION,
  },
  [STEPS.WEDDING_DETAILS_FORM]: {
    component: WeddingDetailsForm,
    key: STEPS.WEDDING_DETAILS_FORM,
  },
  [STEPS.SHIPPING_DETAILS_FORM]: {
    component: ShippingDetailsForm,
    key: STEPS.SHIPPING_DETAILS_FORM,
  },
  [STEPS.ACCOUNT_DETAILS_FORM]: {
    component: AccountDetailsForm,
    key: STEPS.ACCOUNT_DETAILS_FORM,
  },
  [STEPS.SAMPLE_PREVIEW]: {
    component: SamplePreviewStage,
    key: STEPS.SAMPLE_PREVIEW,
  },
  [STEPS.FLOW_COMPLETION]: {
    component: FlowCompletion,
    key: STEPS.FLOW_COMPLETION,
    disableTracking: true,
  },
};
